/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type RecoveryCodeList_recoveryCodes$ref = any;
type RecoveryCodes_totp$ref = any;
type TwoFactorConfigure_viewer$ref = any;
type TwoFactorDelete_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type TwoFactor_viewer$ref: FragmentReference;
declare export opaque type TwoFactor_viewer$fragmentType: TwoFactor_viewer$ref;
export type TwoFactor_viewer = {|
  +permissions: {|
    +totpConfigure: {|
      +allowed: boolean,
      +code: ?string,
      +message: ?string,
    |}
  |},
  +totp: ?{|
    +id: string,
    +recoveryCodes: {|
      +codes: $ReadOnlyArray<{|
        +code: string,
        +consumed: boolean,
      |}>,
      +$fragmentRefs: RecoveryCodeList_recoveryCodes$ref,
    |},
    +$fragmentRefs: RecoveryCodes_totp$ref,
  |},
  +$fragmentRefs: TwoFactorConfigure_viewer$ref & TwoFactorDelete_viewer$ref,
  +$refType: TwoFactor_viewer$ref,
|};
export type TwoFactor_viewer$data = TwoFactor_viewer;
export type TwoFactor_viewer$key = {
  +$data?: TwoFactor_viewer$data,
  +$fragmentRefs: TwoFactor_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TwoFactor_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ViewerPermissions",
      "kind": "LinkedField",
      "name": "permissions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Permission",
          "kind": "LinkedField",
          "name": "totpConfigure",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowed",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "message",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TOTP",
      "kind": "LinkedField",
      "name": "totp",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RecoveryCodeBatch",
          "kind": "LinkedField",
          "name": "recoveryCodes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecoveryCode",
              "kind": "LinkedField",
              "name": "codes",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "consumed",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RecoveryCodeList_recoveryCodes"
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RecoveryCodes_totp"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TwoFactorConfigure_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TwoFactorDelete_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e3c804b3372143e71e1440058361bc58';

module.exports = node;
